module.exports = __webpack_public_path__ + "static/media/rectangle-21.4970f52b.svg";